import { useLoggingMutation } from 'lib/apollo/apollo-hooks';
import { TRANSLATE_ACTIVITIES } from './lang.graphql';
import type {
  TranslateActivitiesMutation,
  TranslateActivitiesMutationVariables,
} from './lang.graphql.generated';

const useTranslateActivities = () => {
  const [translate, { loading, error }] = useLoggingMutation<
    TranslateActivitiesMutation,
    TranslateActivitiesMutationVariables
  >(TRANSLATE_ACTIVITIES);

  return {
    translate,
    loading,
    error,
  };
};

export default useTranslateActivities;
